// extracted by mini-css-extract-plugin
module.exports = {"adminPage":"adminPage_adminPage__3CvYh","link":"adminPage_link__3cf92","container":"adminPage_container__1_d6Y"};